import React, { useState, useEffect, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';
import Language from './Language';

const ButtonModal = ({
  language,
  classes,
  target,
  icon,
  iconClasses,
  textPrimary,
  textSecondary,
  textColor,
  clipboard,
}) => {
  const defaultCountDown = 9;
  const [toggleModal, setToggleModal] = useState(false);

  const [time, setTime] = useState(Date.now());
  const [seconds, setSeconds] = useState(defaultCountDown);

  const actionButton = useRef(null);

  useEffect(() => {
    if (!clipboard && toggleModal === true) {
      const interval = setInterval(() => {
        setTime(Date.now());
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          actionButton.current.click();
          setToggleModal(false);
        }
      }, 1000);

      toggleModal === false && clearInterval(interval);

      return () => {
        clearInterval(interval);
      };
    }
  }, [time, seconds, toggleModal]);

  return (
    <>
      <button
        className={`${classes} d-flex gap-2 justify-content-between align-items-center`}
        onClick={() => {
          setSeconds(defaultCountDown);
          setToggleModal(toggleModal ? false : true);
        }}
      >
        <span>
          {textPrimary}{' '}
          {textSecondary && <span className='fw-normal'> {textSecondary}</span>}
        </span>
        <i className={`${icon} ${iconClasses} fs-4 py-1`}></i>
      </button>

      <Modal
        show={toggleModal}
        size='md'
        onHide={() => {
          setToggleModal(false);
        }}
        centered
        className='bg-blur-sm bg-blue-light'
        contentClassName='rounded-xxl overflow-hidden bg-white m-0 shadow-header-2 position-relative'
      >
        <div className='position-absolute w-100 top-0'>
          <div className='d-flex flex-row-reverse p-2'>
            <a
              className='btn-main text-dark bg-white fw-semibold py-1'
              onClick={() => setToggleModal(false)}
            >
              <i className='mdi mdi-close fs-4'></i>
            </a>
          </div>
        </div>
        <div className='text-center p-3'>
          <div className='pt-2 px-2'>
            {icon ? (
              <i className={`${icon} fs-1 text-blue`}></i>
            ) : (
              <i className='uil-external-link-alt h1 text-blue'></i>
            )}

            <h4 className='pb-2 text-blue'>{textPrimary}</h4>

            {clipboard ? (
              <>
                <p className='mb-3'>
                  <Language
                    language={language}
                    text='link information'
                    textSpecial={textPrimary}
                  />
                </p>
                <p>
                  <span className='fw-bold fs-5 py-2 px-3 border rounded-xl bg-light'>
                    {clipboard}
                  </span>
                </p>

                <div className='row container m-0 p-0 pt-2'>
                  <div className='col-12 m-0 p-0'>
                    <div className='d-flex flex-column gap-3 justify-content-center m-0 p-0 pt-2 fs-6'>
                      <a
                        className='btn-main py-3 bg-white text-blue'
                        onClick={() =>
                          navigator.clipboard.writeText(clipboard.toString())
                        }
                      >
                        <Language language={language} text='link clipboard' />
                      </a>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <p>
                  <Language
                    language={language}
                    text='link redirecting'
                    textSpecial={{
                      direction: textPrimary,
                      timer: seconds.toString(),
                    }}
                  />
                </p>

                <div className='row container m-0 p-0'>
                  <div className='col-12 m-0 p-0'>
                    <div className='d-flex flex-column gap-3 justify-content-center align-items-center m-0 p-0 pt-2'>
                      <a
                        className='btn-main text-white bg-blue fw-semibold col-12 d-flex justify-content-between align-items-center'
                        href={target}
                        ref={actionButton}
                      >
                        <span className='ps-1'>
                          <Language language={language} text='go now' />
                        </span>
                        <i className='uil-external-link-alt fs-5 py-2'></i>
                      </a>
                      <a
                        className='btn-main text-white bg-blue fw-semibold col-12 d-flex justify-content-between align-items-center'
                        onClick={() => setToggleModal(false)}
                        href={target}
                        target={target}
                      >
                        <span className='ps-1'>
                          <Language language={language} text='open tab' />
                        </span>
                        <i className='mdi mdi-content-duplicate fs-5 py-2'></i>
                      </a>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ButtonModal;
